// <div data-controller="identity-verification">
//
// </div>
import { Controller } from "@hotwired/stimulus";
import api from "@/utils/api";
import * as PortOne from "@portone/browser-sdk/v2";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [ "name", "phone", "label" ];
  static classes = [ "" ]
  static values = {
    storeId: String,
    identityVerificationId: String,
    channelKey: String,
    submitUrl: String, // format: :json
    redirectUrl: String // .json 없이
  };

  initialize() {

  }

  connect() {

  }

  get flashesController() {
    return this.application.getControllerForElementAndIdentifier(document.getElementById("flashesContainer"), "components--flashes")
  }

  get requestParams() {
    return {
      storeId: this.storeIdValue,
      identityVerificationId: this.identityVerificationIdValue,
      channelKey: this.channelKeyValue,
      redirectUrl: this.redirectUrlValue
    }
  }

  showError(message) {
    let flashParams = { ttl: 15, stack: false, key: "error" };
    flashParams.message = message;
    this.flashesController.createFlash(flashParams);
  }

  askValidation() {
    this.showError("본인인증을 통해 사용자 정보를 먼저 입력해주세요.");

    this.nameTarget.classList.add("border-red-700", "dark:border-red-300", "text-red-700", "dark:text-red-300");
    this.phoneTarget.classList.add("border-red-700", "dark:border-red-300", "text-red-700", "dark:text-red-300");

    this.labelTarget.innerText = "사용자 정보를 입력해주세요";
    this.labelTarget.style.display = "block"
    this.labelTarget.scrollIntoView();
  }

  async start() {
    let response;

    if (process.env.NODE_ENV === "development") {
      response = { identityVerificationId: this.identityVerificationIdValue }
    } else {
      try {
        response = await PortOne.requestIdentityVerification(this.requestParams);
      } catch (error) {
        // Promise rejection 에러를 처리
        console.error("PortOne 본인인증 오류:", error);
        const errorMessage = error.message || "본인인증 창 호출에 실패하였습니다.";
        return this.showError(errorMessage);
      }
    }

    const {
      identityVerificationId, identityVerificationTxId,
      code, message, pgMessage
    } = response;

    // 프로세스가 제대로 완료되지 않은 경우 에러 코드가 존재합니다
    if (code !== undefined) {
      const decodedMessage = pgMessage ? decodeURIComponent(pgMessage.replace(/\+/g, ' ')) : '';
      const fullMessage = [message, decodedMessage].join(" ")
      console.log(fullMessage);

      return this.showError(fullMessage);
    }

    api.post(this.submitUrlValue, {
      identityVerificationId: identityVerificationId // 모바일에서 redirectUrl 로 올 때 identityVerificationId 키로 오기 때문에 통일함
    }).then((_response) => {
      if (window.opener) { // 레거시 팝업 형식일 경우
        window.opener.location.reload(true);
        window.close();
      } else {
        window.location.reload();
      }
    }).catch((e) => {
      console.log(e)
      console.log(e.response.data)
      this.showError(e.response.data.error);
    })
  }

  disconnect() {

  }
}